<form [formGroup]="passwordForm" (ngSubmit)="actRc()" autocomplete="off" class="item p-4 my-auto">
    <div class="px-3">
        <div class="mt-2 mb-4">
            <h4 class="fw-semibold text-white" *ngIf="!caducada; else caducadaTemplate">
                Cambio de contraseña
            </h4>
            <ng-template #caducadaTemplate>
                <h4 class="fw-semibold text-white">
                    Contraseña caducada
                </h4>
                <p class="text-white">
                    Tu contraseña actual ha caducado. Por favor, registra una nueva contraseña
                </p>
            </ng-template>
        </div>
        <div class="form-field">
            <label htmlFor="oldPassword" for="oldPassword" class="form-label">Contraseña actual</label>
            <div class="action-button">
                <input [type]="hideActual ? 'password': 'text'" class="form-control background-icon"
                    [ngClass]="[hideActual ? 'form-password-show' : 'form-password-hide', caducada? passwordForm.controls.oldPassword.valid ? 'success':'' : validPassword ? 'success':'']" placeholder="*Contraseña"
                    id="oldPassword" formControlName="oldPassword" autocomplete="off">
                <span (click)="hideActual=!hideActual"></span>
            </div>
            <div *ngIf="passwordForm.get('oldPassword')?.errors?.incorrect && !passwordForm.controls.oldPassword.pristine"
                class=" form-error">
                Contraseña incorrecta
            </div>
        </div>
    </div>
    <hr class="d-none d-md-block  bg-sky">
    <div class="px-3 mt-4 mt-md-0">
        <div class="form-field">
            <label htmlFor="newPassword" for="newPassword" class="form-label">Nueva contraseña</label>
            <div class="action-button">
                <input [type]="hideNueva ? 'password': 'text'" class="form-control background-icon"
                    [ngClass]="[hideNueva ? 'form-password-show' : 'form-password-hide', passwordForm.get('newPassword').valid ? 'success':'']"
                    placeholder="*Contraseña" id="newPassword" formControlName="newPassword" autocomplete="off">
                <span (click)="hideNueva=!hideNueva"></span>
            </div>
        </div>
        <div *ngIf="passwordForm.controls.newPassword.value" @growVertical>
            <app-password-validation [password]="passwordForm.get('newPassword').value"></app-password-validation>
        </div>
        <div class="form-field">
            <label htmlFor="confirmPassword" for="confirmPassword" class="form-label">Confirmar nueva
                contraseña</label>
            <div class="action-button">
                <input [type]="hideConfirma ? 'password': 'text'" class="form-control background-icon"
                    [ngClass]="[hideConfirma ? 'form-password-show' : 'form-password-hide', passwordForm.controls.confirmPassword.valid ? 'success':'']"
                    placeholder="*Contraseña" id="confirmPassword" formControlName="confirmPassword" autocomplete="off">
                <span (click)="hideConfirma=!hideConfirma"></span>
            </div>
            <div *ngIf="!passwordForm.controls.confirmPassword.valid && !passwordForm.controls.confirmPassword.pristine" class=" form-error">
                Las contraseñas no coinciden
            </div>
        </div>
    </div>
    <div class="d-flex justify-content-center flex-column align-items-center">
        <button-look-feel class="my-3" [type]="'submit'" [size]="'large'" color="secondary"
            [disabled]="!passwordForm.valid || passwordForm.get('newPassword')?.disabled || passwordForm.get('confirmPassword')?.disabled">Cambiar
            contraseña</button-look-feel>
        <app-hyperlink-icon *ngIf="!caducada" class="mb-3" icon="arrow-left" (clicked)="goToProfile()">Volver a mi
            perfil</app-hyperlink-icon>
    </div>
</form>